<template>
  <div class="tree-list">
    <div v-for="(item, index) in treeList" :key="index" class="tree-list-item">
      <span class="tree-list-item-label">
        <yxt-tooltip placement="top-start" :max-width="500">
          <span slot="content"><yxtbiz-dept-name :name="item.name"/></span>
          <yxtbiz-dept-name :name="item.name" />
        </yxt-tooltip>
      </span>
      <span class="tree-list-item-tool" @click.stop>
        <span
          v-if="item.h"
          class="tree-list-item-tool-next"
          @click="handleNext(item)"
          >下级</span
        >
        <yxt-dropdown
          v-if="functions && funs.length > 0"
          custom-elm
          :dropdownToBody="dropdownToBody"
          @visible-change="visibleChange"
        >
          <span class="color-gray-6 hover-primary-6 yxtbiz-base-tree-slot-icon"
            ><yxt-svg width="16px" height="16px" icon-class="set"
          /></span>
          <yxt-dropdown-menu slot="dropdown">
            <yxt-dropdown-item
              v-for="(funsItem, index) in funs"
              :key="index"
              :disabled="funsItem.disabled || false"
              @click.native="dropdownItemHandle(funsItem)"
            >
              <span
                ><span>{{ funsItem.label }}</span></span
              >
            </yxt-dropdown-item>
          </yxt-dropdown-menu>
        </yxt-dropdown>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    treeList: {
      type: Array,
      default: () => []
    },
    functionsRender: {
      type: Function,
      default: () => [{ label: '操作' }]
    },
    functions: {
      type: Boolean,
      default: true
    },
    placement: {},
    settingIcon: {
      default: 'yxt-icon-setting'
    },
    dropdownToBody: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      funs: []
    };
  },
  created() {
    this.showDropdown();
  },
  methods: {
    handleNext(data) {
      this.$emit('next', data);
    },
    dropdownItemHandle(funsNode) {
      if (funsNode.disabled) return;
      if (funsNode.handler && typeof funsNode.handler === 'function') {
        funsNode.handler(this.node, this.data);
      }
    },
    visibleChange(bool) {
      if (bool) {
        this.showDropdown();
      }
    },
    showDropdown() {
      const funsRender = this.functionsRender(this.data);
      if (funsRender && funsRender.length) {
        this.funs = funsRender;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.tree-list {
  padding: 0 10px;
  &-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-label {
      width: calc(100% - 70px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &-tool {
      width: 70px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      &-next {
        color: #436bff;
        cursor: pointer;
        margin-right: 10px;
      }
      .yxtbiz-base-tree-slot-icon {
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
